import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import api from '../services/api'; // CORREÇÃO AQUI: Importar como default

const ResetPassword = () => {
    const navigate = useNavigate();
    const location = useLocation(); // Para pegar o token da URL

    const [token, setToken] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        // Extrai o token da URL
        const queryParams = new URLSearchParams(location.search);
        const urlToken = queryParams.get('token');
        if (urlToken) {
            setToken(urlToken);
        } else {
            setError('Token de redefinição não encontrado na URL.');
        }
    }, [location]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setMessage('');
        setError('');

        if (!token) {
            setError('Token de redefinição ausente.');
            setIsSubmitting(false);
            return;
        }

        if (newPassword.length < 6) {
            setError('A nova senha deve ter pelo menos 6 caracteres.');
            setIsSubmitting(false);
            return;
        }

        if (newPassword !== confirmPassword) {
            setError('As senhas não coincidem.');
            setIsSubmitting(false);
            return;
        }

        try {
            await api.post('/password/reset', { token, newPassword });
            setMessage('Senha redefinida com sucesso! Você pode fazer login agora.');
            setNewPassword('');
            setConfirmPassword('');
            // Opcional: Redirecionar para a página de login após alguns segundos
            setTimeout(() => {
                navigate('/login');
            }, 3000);
        } catch (err) {
            setError(err.response?.data?.message || 'Erro ao redefinir a senha.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div style={pageStyle}>
            <div style={contentBoxStyle}>
                <h1 style={titleStyle}>Redefinir Senha</h1>
                {!token && <p style={errorMessageStyle}>Token de redefinição inválido ou ausente.</p>}
                {message && <p style={successMessageStyle}>{message}</p>}
                {error && <p style={errorMessageStyle}>{error}</p>}

                {token && !message && ( // Mostra o formulário apenas se tiver token e ainda não tiver mensagem de sucesso
                    <form onSubmit={handleSubmit}>
                        <div style={formGroupStyle}>
                            <label style={labelStyle}>Nova Senha:</label>
                            <input
                                type="password"
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                                required
                                style={inputStyle}
                                disabled={isSubmitting}
                            />
                        </div>
                        <div style={formGroupStyle}>
                            <label style={labelStyle}>Confirmar Nova Senha:</label>
                            <input
                                type="password"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                required
                                style={inputStyle}
                                disabled={isSubmitting}
                            />
                        </div>
                        <button type="submit" style={submitButtonStyle} disabled={isSubmitting}>
                            {isSubmitting ? 'Redefinindo...' : 'Redefinir Senha'}
                        </button>
                    </form>
                )}
            </div>
        </div>
    );
};

// --- ESTILOS DA PÁGINA DE REDEFINIÇÃO ---
const pageStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #3498db 0%, #2ecc71 100%)',
    padding: '20px'
};

const contentBoxStyle = {
    backgroundColor: 'white',
    padding: '30px',
    borderRadius: '8px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
    width: '100%',
    maxWidth: '450px',
    textAlign: 'center'
};

const titleStyle = {
    marginBottom: '25px',
    color: '#2c3e50',
    fontSize: '2rem'
};

const formGroupStyle = {
    marginBottom: '15px',
    textAlign: 'left'
};

const labelStyle = {
    display: 'block',
    marginBottom: '5px',
    fontWeight: '600',
    color: '#555',
    fontSize: '0.9rem',
};

const inputStyle = {
    width: '100%',
    padding: '10px',
    border: '1px solid #ddd',
    borderRadius: '4px',
    fontSize: '1rem',
    boxSizing: 'border-box',
};

const submitButtonStyle = {
    backgroundColor: '#3498db',
    color: 'white',
    padding: '12px 20px',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontWeight: '600',
    fontSize: '1.1rem',
    width: '100%',
    marginTop: '20px',
    transition: 'background-color 0.2s ease'
};

const successMessageStyle = {
    color: '#28a745',
    backgroundColor: '#d4edda',
    padding: '15px',
    borderRadius: '4px',
    marginBottom: '20px',
    fontSize: '1rem',
    textAlign: 'center',
    border: '1px solid #c3e6cb'
};

const errorMessageStyle = {
    color: '#dc3545',
    backgroundColor: '#f8d7da',
    padding: '15px',
    borderRadius: '4px',
    marginBottom: '20px',
    fontSize: '1rem',
    textAlign: 'center',
    border: '1px solid #f5c6cb'
};

export default ResetPassword;